<script setup lang="ts">
import { useHead } from "@unhead/vue";
import api from "@virgodev/bazaar/functions/api";
import { ref } from "vue";
import { RouterView } from "vue-router";
import { useStore } from "@/stores";

import Toast from "primevue/toast";

const store = useStore();

const originalTitle = document.title;

useHead({
  titleTemplate: (title?: string) => {
    return (title !== undefined ? `${title} · ` : "") + originalTitle;
  },
});

const appLaunchDataStatus = ref<"loading" | "loaded" | "error">("loading");

async function loadAppLaunchData() {
  appLaunchDataStatus.value = "loading";

  const responseData = await api({ url: "app-launch/" });

  if (responseData.status === 200) {
    store.officeOptions = responseData.body.office_options;
    store.partnerOptions = responseData.body.partner_options;
    store.planOptions = responseData.body.plan_options;

    document.documentElement.classList.remove("app-not-launched");
    appLaunchDataStatus.value = "loaded";
  } else {
    appLaunchDataStatus.value = "error";
  }
}

loadAppLaunchData();
</script>
<template>
  <template v-if="appLaunchDataStatus === 'loaded'">
    <RouterView />
    <Toast ref="toast" position="top-right" />
  </template>

  <main v-else>
    <ProgressSpinner v-if="appLaunchDataStatus === 'loading'" class="d-block" />

    <div
      v-else-if="appLaunchDataStatus === 'error'"
      class="centered-message-and-button"
    >
      <Message severity="error">
        Unable to communicate with the server. Please check your connection.
      </Message>

      <Button label="Try Again" @click="loadAppLaunchData" />
    </div>
  </main>
</template>
